import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SsoProviderGuard implements CanActivate {

  /**
   * Constructor
   *
   * @param {AuthService} authService
   * @param {Router} router
   */
  public constructor(private authService: AuthService, private router: Router) { }

  /**
   * Checks if a route can be accessed
   *
   * @param {ActivatedRouteSnapshot} next
   * @param {RouterStateSnapshot} state
   *
   * @return {boolean | Promise<boolean>}
   */
  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    return next.queryParams['code'] ? true : this.router.navigate(['/']);
  }
}
